import {Component, ViewChild} from '@angular/core';
import {GenericDataViewService} from "../generic-data-view.service";
import {IonicPage, NavController, NavParams} from "ionic-angular";
import {HttpClient} from "@angular/common/http";
import {TableRendererComponent} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/table/table.component";
import {TableConfig} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/table/interfaces/table-config.interface";
import {AuthenticationServiceProvider} from "../../modules/core/services/authentication-service/authentication-service";
import {TableNavigationEvent} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/table/interfaces/navigation-event.interface";

@IonicPage()
@Component({
  selector: 'generic-data-view-table',
  templateUrl: './generic-data-view-table.page.html',
})
export class GenericDataViewTablePage {
  @ViewChild(TableRendererComponent)
  table!: TableRendererComponent;
  public config: TableConfig;
  public title: string = '';
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
    private navParams: NavParams,
    private genericDataViewService: GenericDataViewService,
    private authService: AuthenticationServiceProvider,
    private navController: NavController
  ) {}

  ionViewWillEnter() {
    const layout = this.navParams.data;
    this.title = layout.title;
    this.authService.getAccessToken().then(token => {
      const config = this.genericDataViewService.getConfig(layout.viewId);
      config.dataSourceConfig.token = token;
      this.genericDataViewService.setConfigBaseUrl(config);
      this.config = config;
    });
  }

  ionViewDidEnter() {
    if (this.table) {
      this.loading = true;
      this.table.reloadData();
    }
  }

  public setLoading(loading: boolean): void {
    setTimeout(() => (this.loading = loading));
  }

  public navigate(params: TableNavigationEvent): void {
    this.navController.push(params.commands[0], params.opts)
  }

}



// WEBPACK FOOTER //
// ./src/generic-data-view/generic-data-view-table/generic-data-view-table.page.ts